const issue_with_renovation = `Hei, halusin keskustella asuntoni äskettäin tehdystä remontista,
erityisesti keittiön suunnittelussa. En ole täysin tyytyväinen lopputulokseen.
Keittiössä on joitain puolia, jotka eivät vastanneet odotuksiani,
ja uskon, että parantamisen varaa on.
Toivoin, että voisimme keskustella siitä, kuinka voisimme ratkaista nämä huolenaiheet.
Arvostan apuasi tämän asian ratkaisemisessa. Kiitos.`;

export default issue_with_renovation;